module.exports = __webpack_public_path__ + "static/media/IMG_0164.601437fc.jpg";